import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboard'
import { dashboard } from '../querykeys/dashboard'

export const useDashboardProgressReport = (isEnable, date) => {
  return useQuery([dashboard.DASHBOARD, date], dashboardApi.getDashboardProgressReport, {
    enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
export const useDashboardRecentActivity = (isEnable, date) => {
  return useQuery([dashboard.DASHBOARDRECENT, date], dashboardApi.getDashboardRecentActivity, {
    enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
export const useDashboardTaskStatus = (isEnable, page, status, date, selectedDepartment) => {
  return useQuery([dashboard.DASHBOARDTASKSTATUS, status, page, date, selectedDepartment], dashboardApi.getDashboardTaskStatus, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
export const useDashboardJobcardStatus = (isEnable, page, status, date, selectedDepartment) => {
  return useQuery([dashboard.DASHBOARDJOBSTATUS, status, page, date, selectedDepartment], dashboardApi.getDashboardJobcardStatus, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
export const useDashboardJobcardTaskStatus = (isEnable, page, status, date) => {
  return useQuery([dashboard.DASHBOARDJOBCARDTASKSTATUS, status, page, date], dashboardApi.getDashboardJobcardTaskStatus, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}

// -------------------------------------ADMIN DASHBOARD ---------------------------------------------//
// machine pie chart and bar chart list
export const useAdminMachineTime = () => {
  return useQuery([dashboard.ADMINMACHINETIME], dashboardApi.getAdminMachineTime, {
    // enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
// ! new one---------------machine pie chart single
export const useSingleMachine = (id, isEnable) => {
  return useQuery([dashboard.MACHINE_SINGLE, id], dashboardApi.getSingleMachine, {
    enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
// bar chart single
export const useSingleDepartment = (id, isEnable) => {
  return useQuery([dashboard.DEPARTMENT_SINGLE, id], dashboardApi.getSingleDepartment, {
    enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
// Machine list
export const useAdminMachineList = () => {
  return useQuery([dashboard.MACHINE_LIST], dashboardApi.getAdminMachine, {
    // enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
// four box starting of dashboard
export const useAdminAllCount = () => {
  return useQuery([dashboard.ADMINALLCOUNT], dashboardApi.getAdminAllCount, {
    // enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}

export const useAdminDashboardRecentActivity = () => {
  return useQuery([dashboard.ADMINDASHBOARDRECENT], dashboardApi.getAdminDashboardRecentActivity, {
    // enabled: isEnable,
    onSuccess: (data) => {
      // queryClient.setQueryData([taskStatus.MACHINEWISEKANBAN], 'hi')
    },
    keepPreviousData: true,
    // enabled: isEnabled,
    refetchOnWindowFocus: false
  })
}
// Task overview list
export const useAdminDashboardTaskOverview = () => {
  return useQuery([dashboard.ADMINTASKOVERVIEW], dashboardApi.getAdminTaskOverview, {
    // enabled: isEnable,
    select: (res) => res?.data,
    refetchOnWindowFocus: false
  })
}
// BreakDown list
export const useAdminBreakDown = (isEnable, page, date) => {
  return useQuery([dashboard.ADMINBREAKDOWN, page, date], dashboardApi.getAdminBreakDown, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}

// -------------------------------------Manager DASHBOARD ---------------------------------------------//

export const useManagerOverView = (selectedDepartment) => {
  return useQuery([dashboard.DASHBOARDTASKSTATUS, selectedDepartment], dashboardApi.getManagerOverview, {
    // enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
// Ongoing task
export const useManagerApprovetask = (isEnable, page, date, selectedDepartment) => {
  return useQuery([dashboard.MANAGERAPPROVETASK, page, date, selectedDepartment], dashboardApi.getManagerApproveTasks, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
// shceduled task
export const useManagerScheduledtask = (isEnable, page, date, selectedDepartment) => {
  return useQuery([dashboard.MANAGERSCHEDULEDTASK, page, date, selectedDepartment], dashboardApi.getManagerScheduledTasks, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
// shceduled task
export const useManagerOngoingtask = (isEnable, page, date, selectedDepartment) => {
  return useQuery([dashboard.MANAGERONGOINTASK, page, date, selectedDepartment], dashboardApi.getManagerOngoingTasks, {
    enabled: isEnable,
    select: (res) => res?.data,
    // ! TODO: for future implementation toast
    // onSuccess: () => {
    //   // const data = res?.data;
    // },
    // onError: (err) => {
    //   return err;
    //   // const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
